import {Component, OnInit} from '@angular/core';
import {MatIconRegistry} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    this.addSvgIcon('nav/menu', 'assets/cui/nav/menu.svg');
    this.addSvgIcon('nav/back', 'assets/cui/nav/back.svg');
    this.addSvgIcon('nav/help', 'assets/cui/nav/help.svg');
    this.addSvgIcon('nav/log-out', 'assets/cui/nav/log-out.svg');
    this.addSvgIcon('nav/pickup-list', 'assets/cui/nav/pickup-list.svg');
    this.addSvgIcon('nav/materials', 'assets/cui/nav/search-white.svg');
    this.addSvgIcon('nav/close-black', 'assets/cui/nav/close-black.svg');
    this.addSvgIcon('nav/filter', 'assets/cui/nav/filter.svg');
    this.addSvgIcon('nav/content', 'assets/cui/nav/content.svg');

    this.addSvgIcon('material-types/composite-materials', 'assets/cui/material-types/composite-materials.svg');
    this.addSvgIcon('material-types/electronic', 'assets/cui/material-types/electronic.svg');
    this.addSvgIcon('material-types/image', 'assets/cui/material-types/image.svg');
    this.addSvgIcon('material-types/map', 'assets/cui/material-types/map.svg');
    this.addSvgIcon('material-types/music', 'assets/cui/material-types/music.svg');
    this.addSvgIcon('material-types/object', 'assets/cui/material-types/object.svg');
    this.addSvgIcon('material-types/text', 'assets/cui/material-types/text.svg');
    this.addSvgIcon('material-types/video', 'assets/cui/material-types/video.svg');
    this.addSvgIcon('material-types/ill', 'assets/cui/material-types/ill.svg');

    this.addSvgIcon('material-states/found', 'assets/cui/material-states/found-white.svg');
    this.addSvgIcon('material-states/not-found', 'assets/cui/material-states/not-found-white.svg');
    this.addSvgIcon('material-states/not-found-blue', 'assets/cui/material-states/not-found-blue.svg');
    this.addSvgIcon('material-states/lost', 'assets/cui/material-states/lost-white.svg');
    this.addSvgIcon('material-states/lost-blue', 'assets/cui/material-states/lost-blue.svg');
    this.addSvgIcon('material-states/skipped', 'assets/cui/material-states/skipped-white.svg');
    this.addSvgIcon('material-states/skipped-blue', 'assets/cui/material-states/skipped-blue.svg');
    this.addSvgIcon('material-states/undo', 'assets/cui/material-states/undo-white.svg');
    this.addSvgIcon('material-states/undo-blue', 'assets/cui/material-states/undo-blue.svg');

    this.addSvgIcon('logo/full-white', 'assets/cui/logo/cicero-move-white.svg');
    this.addSvgIcon('loading', 'assets/cui/placeholder/bookstack.svg');
    this.addSvgIcon('no-results', 'assets/cui/placeholder/surprised-face.svg');
    this.addSvgIcon('login-14x', 'assets/cui/auth/login-14x-white.svg');
    this.addSvgIcon('login-22x', 'assets/cui/auth/login-22x-white.svg');
    this.addSvgIcon('password', 'assets/cui/auth/password-white.svg');
  }

  ngOnInit() {

  }

  private addSvgIcon(iconName: string, url: string) {
    return this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(url));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts